import { Injectable } from '@angular/core';
import { MenuApi } from './menu.api';
import { UserStoreService } from '@/core/stores/user-store.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { MenusItem } from '@/layout/models/menu-item';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    constructor(
        private readonly menuApi: MenuApi,
        private readonly userStoreService: UserStoreService
    ) { }
    private menuItemSubject = new BehaviorSubject<MenusItem[]>([]);
    menuItems$ = this.menuItemSubject.asObservable();

    setMenuItems(items: MenusItem[]) {
        this.menuItemSubject.next(items);
    }
    getMenuItem(): Observable<MenusItem[]> {
        return this.menuItemSubject.asObservable();
    }

    getMenusByRoleId() {
        const roleCode = this.userStoreService.getUser()?.roleCode || '';

        return this.menuApi.getMenusByRoleId(roleCode);
    }

    getMenusForSelect() {
        return this.menuApi.getMenusForSelect();
    }
}